// @flow

import { toastr } from "react-redux-toastr";

import { makeApiCall } from "../../../../../services/apiService/apiService";

export const resolverGroupActions = {
  GET_LOCATION_DATA: "GET_LOCATION_DATA",
  GET_USER_DATA_BY_LOCATION: "GET_USER_DATA_BY_LOCATION",
  GET_GROUPS: "GET_GROUPS",
  CREATE_GROUP: "CREATE_GROUP"
};

export const getLocationDataAction = (obj: Object) => ({
  type: resolverGroupActions.GET_LOCATION_DATA,
  payload: obj
});

export const getUserDataByLocationAction = (obj: Object) => ({
  type: resolverGroupActions.GET_USER_DATA_BY_LOCATION,
  payload: obj
});

export const getGroupsAction = (obj: Object) => ({
  type: resolverGroupActions.GET_GROUPS,
  payload: obj
});

export const createGroupSubmitAction = (obj: Object) => ({
  type: resolverGroupActions.CREATE_GROUP,
  payload: obj
});

export const getLocationData = () => (dispatch: Function) => {
  dispatch(
    getLocationDataAction({
      isLoading: true,
      isLoaded: false,
      data: []
    })
  );

  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "ticketingGroup",
    successCb: res => {
      // eslint-disable-next-line
      console.log("Fetched location data ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getLocationDataAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getLocationDataAction({
            isLoading: false,
            isLoaded: true,
            data: []
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log("Failure in fetching location data ", res);
      dispatch(
        getLocationDataAction({
          isLoading: false,
          isLoaded: true,
          data: []
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log("Exception in fetching location data ", res);
      dispatch(
        getLocationDataAction({
          isLoading: false,
          isLoaded: true,
          data: []
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getUserDataByLocation = (locationCode, searchText) => (
  dispatch: Function
) => {
  dispatch(
    getUserDataByLocationAction({
      isLoading: true,
      isLoaded: false,
      data: []
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "ticketingUsersByLocation",
    replaceParamsArr: [
      { key: "locationCode", val: locationCode },
      { key: "searchText", val: searchText }
    ],
    successCb: res => {
      // eslint-disable-next-line
      console.log("Fetched User data ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getUserDataByLocationAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getUserDataByLocationAction({
            isLoading: false,
            isLoaded: true,
            data: []
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log("Failure in fetching user data ", res);
      dispatch(
        getUserDataByLocationAction({
          isLoading: false,
          isLoaded: true,
          data: []
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log("Exception in fetching user data ", res);
      dispatch(
        getUserDataByLocationAction({
          isLoading: false,
          isLoaded: true,
          data: []
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getGroups = (locationCode, cb = () => {}) => (
  dispatch: Function
) => {
  dispatch(
    getGroupsAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "ticketingResolverGroup",
    method: "GET",
    pathVariables: [{ key: "#locationCode", val: locationCode }],
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched Group data", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getGroupsAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
        cb();
      } else if (res.status === "FAILURE") {
        dispatch(
          getGroupsAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log("Failure in getting groups, res = ", res);
      dispatch(
        getGroupsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log("Exception in getting groups, res = ", res);
      dispatch(
        getGroupsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const createGroupSubmit = (formData: Object, isEdit: Boolean) => (
  dispatch: Function
) => {
  dispatch(
    createGroupSubmitAction({
      isLoading: true,
      isLoaded: false,
      data: null,
      allowAPIcall: false
    })
  );

  // eslint-disable-next-line
  console.log("Group Data: ", formData);
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "ticketingResolverGroupCreate",
    method: isEdit ? "PUT" : "POST",
    data: formData,
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched Group Create Submit ", res);
      if (res.status === "SUCCESS") {
        if (isEdit) {
          toastr.success("Group edited successfully");
        } else {
          toastr.success("Group created successfully");
        }
        dispatch(
          createGroupSubmitAction({
            isLoading: false,
            isLoaded: true,
            data: res.response,
            allowAPIcall: false
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Failure", res && res.errorMessage, {
          timeout: 3000
        });
        dispatch(
          createGroupSubmitAction({
            isLoading: false,
            isLoaded: true,
            data: null,
            allowAPIcall: true
          })
        );
      }
    },
    failureCb: res => {
      toastr.error("Failure", res.errorMessage, {
        timeout: 3000
      });
      dispatch(
        createGroupSubmitAction({
          isLoading: false,
          isLoaded: true,
          data: null,
          allowAPIcall: true
        })
      );
    },
    catchCb: res => {
      toastr.error("Failure", res.errorMessage, {
        timeout: 3000
      });
      dispatch(
        createGroupSubmitAction({
          isLoading: false,
          isLoaded: true,
          data: null,
          allowAPIcall: true
        })
      );
    }
  };
  makeApiCall(requestObj);
};



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/resolverGroup/resolverGroupRedux/resolverGroupActionCreator.js